
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"58.19 58.25 367.46 59.36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m228.06 81.56c-5.47 0-9.35 4.28-9.35 10.85v24.1h-8.35v-42.42h8.25v5.18a11.19 11.19 0 0 1 9.94-5.48h3v7.77zm-23.47 13.74c0-12.65-9-22.11-21.18-22.11a21.83 21.83 0 0 0 -21.68 22.11c0 12.64 9.75 22.2 22.47 22.2a22.17 22.17 0 0 0 18.3-9.06l-6.06-4.44a14.78 14.78 0 0 1 -12.24 6.17 14.22 14.22 0 0 1 -14-12.14h34.41zm-34.21-3.89c1.49-6.47 6.66-10.85 12.93-10.85s11.43 4.38 12.83 10.85zm-35.1-18.22a21.12 21.12 0 0 0 -15 6.27v-21.21h-8.35v58.26h8.25v-5.38a21.45 21.45 0 0 0 15.12 6.37 22.16 22.16 0 1 0 0-44.31zm-.6 36.85a14.69 14.69 0 1 1 14.62-14.64 14.58 14.58 0 0 1 -14.62 14.6zm-53.5-.4c8.06 0 14.32-6.18 14.32-15.44v-35.95h8.65v58.26h-8.55v-5.51a21.24 21.24 0 0 1 -15.41 6.47c-12.43 0-22-9.06-22-22.8v-36.42h8.81v36c0 9.31 6 15.39 14.18 15.39z","fill":"#262626"}}),_c('path',{attrs:{"d":"m252.32 58.25h40.87v10h-29.83v14.2h29v9.66h-29v14.44h29.83v10h-40.87zm153.74 59.35c12.53 0 19.59-6 19.59-14.24 0-5.87-4.18-10.25-12.93-12.15l-9.25-1.89c-5.37-1-7.06-2-7.06-4 0-2.59 2.59-4.18 7.36-4.18 5.17 0 9 1.39 10 6.17h10.84c-.59-9-7.06-14.94-20.18-14.94-11.34 0-19.3 4.68-19.3 13.75 0 6.27 4.38 10.35 13.83 12.34l10.34 2.39c4.08.8 5.17 1.9 5.17 3.59 0 2.69-3.08 4.38-8.06 4.38-6.26 0-9.84-1.39-11.23-6.17h-10.9c1.59 8.98 8.25 14.95 21.78 14.95zm-24.93-1.09h-11.73c-7.36 0-11.44-4.58-11.44-10.36v-22.9h-8.25v-9.76h8.29v-12.25h10.9v12.25h12.23v9.76h-12.23v20.11c0 2.29 1.59 3.39 4.08 3.39h8.15zm-47-43v3.88a21.16 21.16 0 0 0 -13.73-5 22.61 22.61 0 1 0 0 45.21 21.1 21.1 0 0 0 13.73-5v3.89h10.87v-43zm-12.83 34.65a13.15 13.15 0 1 1 13-13.14 13 13 0 0 1 -13.02 13.12z","fill":"#5fb709"}})])
          )
        }
      }
    